import { Component } from '@theme/component';

export class USPCardSlider extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.#initializeSwiper();
  }
  #initializeSwiper() {
    if (typeof Swiper === 'undefined') {
      setTimeout(() => this.#initializeSwiper(), 100);
      return;
    }
    const { thumbnailSwiper, mainSwiper, nextButton, prevButton } = this.refs;
    const timing = parseInt(this.dataset.timing) || 3;
    const delay = timing * 1000;
    const enableAutoplay = this.dataset.autoplay === 'true';
    
    if (thumbnailSwiper && mainSwiper) {
      try {
          const swiper = new Swiper(thumbnailSwiper, {
          loop: true,
          spaceBetween: 0,
          slidesPerView: 'auto',
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          centeredSlides: true,
          slideToClickedSlide: false,
          ...(enableAutoplay && {
            autoplay: {
              delay: delay
            }
          }),
          autoScrollOffset: 1,
          on: {
            realIndexChange: function (e) {
              swiper2.slideTo(e.realIndex);
            },
          }
        });

        const swiper2 = new Swiper(mainSwiper, {
          loop: true,
          spaceBetween: 0,
          effect: 'fade',
          allowTouchMove: false,
          fadeEffect: {
            crossFade: true
          },
          thumbs: {
            swiper: swiper,
          },
        });
        
      } catch (error) {
        console.error('USP Card Slider - Error initializing:', error);
      }
    } else {
      console.warn('USP Card Slider - Missing required elements');
    }
  }
}

if (!customElements.get('usp-card-slider')) {
  customElements.define('usp-card-slider', USPCardSlider);
} 